<core-layout-header />
<core-layout-main class="bg-base-200 flex grow" />
<core-layout-footer />
